<template>
  <div>
    WOCHENAUSWAHL VERFÜGBARE ZEIT
  </div>
</template>

<script>

export default {
  name: "",
  data: () => ({
  }),
  mounted() {
  },
  computed: {
  },
  methods: {
  },
  components: {
  }
}
</script>

<style scoped>
</style>
